<script>
export default {
  data() {
    return {
      title: "Search",
      text: "Search",
    };
  },
};
</script>
<template>
  <layout-header></layout-header>
  <services-breadcrumb :title="title" :text="text" />
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row">
          <services-sidebar></services-sidebar>
          <div class="col-xl-9 col-lg-8">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h4>Found <span class="text-primary">11 Services</span></h4>
              <div class="d-flex align-items-center">
                <span class="text-dark me-2">Sort</span>
                <div class="dropdown me-2">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle bg-light-300"
                    data-bs-toggle="dropdown"
                  >
                    Price Low to High
                  </a>
                  <div class="dropdown-menu">
                    <a href="javascript:void(0);" class="dropdown-item active"
                      >Price Low to High</a
                    >
                    <a href="javascript:void(0);" class="dropdown-item"
                      >Price High to Low</a
                    >
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center bg-primary rounded me-2"
                  ><i class="ti ti-layout-grid"></i
                ></a>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center border rounded"
                  ><i class="ti ti-list"></i
                ></a>
              </div>
            </div>
            <div class="row justify-content-center align-items-center">
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-13.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Car Wash</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Car Repair Service</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Maryland City, MD, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.9</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $25.00 <span class="fs-13 text-gray"><del>$30.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-14.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Construction</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Toughened Glass Fitting</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>New Jersey, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.7</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $20.00 <span class="fs-13 text-gray"><del>$25.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-15.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Computer</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2 text-truncate">
                        <a href="javascript:void(0);">Computer Hardware Service</a>
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>California, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.5</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $20.00 <span class="fs-13 text-gray"><del>$35.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-16.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Interior</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Interior Designing</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Maryland, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.8</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $30.00 <span class="fs-13 text-gray"><del>$35.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-17.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Car Wash</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details">Steam Car Wash</router-link>
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Montana, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.2</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $20.00 <span class="fs-13 text-gray"><del>$25.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-18.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Electrical</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Electric Panel Repairing</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Texas, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.9</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $40.00 <span class="fs-13 text-gray"><del>$45.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-19.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Cleaning</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2 text-truncate">
                        <a href="javascript:void(0);">House Cleaning Services</a>
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>New Jersey, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.6</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $45.00 <span class="fs-13 text-gray"><del>$50.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-20.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Construction</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Commercial Painting
                        </router-link>
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Alabama, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.5</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $40.00 <span class="fs-13 text-gray"><del>$45.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-21.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Appliance</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Air Conditioner Service</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Washington, DC, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.2</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $20.00 <span class="fs-13 text-gray"><del>$25.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-22.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Construction</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Building Construction</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Montana, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.0</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $50.00 <span class="fs-13 text-gray"><del>$55.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-23.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Plumber</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details">Plumbing Services</router-link>
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Virginia, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.3</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $45.00 <span class="fs-13 text-gray"><del>$50.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-24.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <span class="trend-tag">Carpentry</span>
                        <a href="javascript:void(0);" class="fav-icon like-icon"
                          ><i class="ti ti-heart"></i
                        ></a>
                      </div>
                      <span class="image-logo avatar avatar-md border rounded-circle">
                        <img
                          src="@/assets/img/providers/provider-01.jpg"
                          class="img-fluid rounded-circle"
                          alt="logo"
                        />
                      </span>
                    </div>
                    <div class="p-3">
                      <h5 class="mb-2">
                        <router-link to="/details/service-details"
                          >Wooden Carpentry Work</router-link
                        >
                      </h5>
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="fs-14 mb-0">
                          <i class="ti ti-map-pin me-2"></i>Alabama, USA
                        </p>
                        <span class="rating text-gray fs-14"
                          ><i class="fa fa-star filled me-1"></i>4.1</span
                        >
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <h5>
                          $25.00 <span class="fs-13 text-gray"><del>$30.00/hr</del></span>
                        </h5>
                        <router-link to="/booking/booking" class="btn bg-primary-transparent"
                          >Book Now</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <nav aria-label="Page navigation">
              <ul class="paginations d-flex justify-content-center align-items-center">
                <li class="page-item me-3">
                  <a class="page-link"><i class="ti ti-arrow-left me-2"></i>Prev</a>
                </li>
                <li class="page-item me-2">
                  <a
                    class="page-link-1 active d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >1</a
                  >
                </li>
                <li class="page-item me-2">
                  <a
                    class="page-link-1 d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >2</a
                  >
                </li>
                <li class="page-item me-3">
                  <a
                    class="page-link-1 d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >3</a
                  >
                </li>
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0);"
                    >Next<i class="ti ti-arrow-right ms-2"></i
                  ></a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
</template>
